<template>
  <v-col class="pa-0">
    <v-data-table
      :style="tableStyle"
      :headers="headers"
      :items="items"
      :items-per-page="itemsPerPage"
      item-key="uuid"
      hide-default-footer
      @click:row="row => $emit('row-click', row)"
    >
        <!-- name with online indicator (only for operators) -->
        <template v-slot:[`item.username`]="{ item }">
          <div class="d-flex align-center">
            <span v-if="typeof item.online === 'boolean'" :class="['circle', item.online ? 'green' : 'red']" aria-hidden="true"></span>
            <span class="text-body-2">{{ item.username }}</span>
          </div>
        </template>
      <!-- status chip -->
      <template v-slot:[`item.status`]="{ item }">
        <v-chip x-small label :color="getStatusColor(item.status)" dark>{{ item.status }}</v-chip>
      </template>

      <!-- custom footer -->
      <template v-slot:footer>
        <table-footer
          :page="page"
          :page-count="pageCount"
          :items-per-page="itemsPerPage"
          :total="total"
          :items-per-page-options="itemsPerPageOptions"
          @update:page="val => $emit('update:page', val)"
          @update:itemsPerPage="val => $emit('update:itemsPerPage', val)"
        />
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import TableFooter from '../common/TableFooter.vue';

export default {
  name: 'PeopleTable',
  components: { 'table-footer': TableFooter },
  props: {
    headers: { type: Array, required: true },
    items: { type: Array, required: true },      // već ispejdžirano iz parenta
    page: { type: Number, required: true },
    pageCount: { type: Number, required: true }, // ukupan broj stranica
    total: { type: Number, required: true },     // ukupan broj zapisa (za "1–10 of N")
    itemsPerPage: { type: Number, required: true },
    itemsPerPageOptions: {
      type: Array,
      default: () => [5, 10, 15, 20, -1], // -1 = All
    },
    isDark: { type: Boolean, default: false },   // za tamnu temu styling
  },
  computed: {
    tableStyle() {
      return this.isDark
        ? { border: '1px solid #424242', 'background-color': '#212121' }
        : { border: '1px solid #dedede', 'background-color': '#ffffff' };
    },
  },
  methods: {
    getStatusColor(s) {
      if (s === 'Enabled') return 'green';
      if (s === 'Disabled') return 'red';
      return '';
    },
  
  },
};
</script>

<style scoped>
.circle {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;
  margin-right: 8px;
}
.green { background-color: #00a86b; }
.red { background-color: red; }

/* vertical-center all cells and headers */
::v-deep .v-data-table th,
::v-deep .v-data-table td {
  vertical-align: middle !important;
}
</style>
